import { auth } from '@langlois/vuex-auth';
import { club } from '@/store/module/club/club.js';
import { competition } from '@/store/module/competition/competition.js';
import { member } from '@/store/module/member/member.js';
import { membership } from '@/store/module/membership/membership.js';
import { scheduler } from '@/store/module/scheduler/scheduler.js';
import { subscription } from '@/store/module/subscription/subscription.js';
import { team } from '@/store/module/team/team.js';

export const modules = {
	auth,
	club,
	competition,
	member,
	membership,
	scheduler,
	subscription,
	team
};
